var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntersection = function SvgIntersection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274,
    height: 376,
    fill: "none",
    role: "presentation"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 137,
    r: 137,
    fill: "#000",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 239,
    r: 137,
    fill: "#000",
    fillOpacity: 0.1
  })));
};
export default SvgIntersection;